import React, { FC } from 'react';
import styles from './CustomerTaxeItem.module.scss';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import { ReactComponent as BillIcon } from './img/BillIcon.svg';
import { TaxesItemsTypes } from 'redux/Api/taxesApi/type';

interface CustomerTaxeItemTypes {
  taxe: TaxesItemsTypes;
}

export const CustomerTaxeItem: FC<CustomerTaxeItemTypes> = ({ taxe }) => {
  return (
    <div className={styles.root}>
      <p className={styles.root_text}>
        <span>{taxe.worker_id}</span>
      </p>
      <div
        className={styles.root_item}
        style={{ display: 'flex', flexDirection: 'column' }}>
        <p className={styles.root_item__standart}>{taxe.worker_fio}</p>
        <div style={{ display: 'flex', columnGap: '10px' }}>
          <p className={styles.root_item__for_ndfl}>ИНН {taxe.worker_inn}</p>
        </div>
      </div>
      <p className={styles.root_text} style={{ textAlign: 'end' }}>
        {addSpaceNumber(taxe.amount_in_taxbox)}
      </p>
      <p className={styles.root_text} style={{ textAlign: 'end' }}>
        {addSpaceNumber(taxe.amount_to_pay)}
      </p>
      <p className={styles.root_text} style={{ textAlign: 'end' }}>
        {addSpaceNumber(taxe.amount_paid)}
      </p>
      <p className={styles.root_text} style={{ textAlign: 'end' }}>
        {addSpaceNumber(taxe.amount_to_return)}
      </p>
      <p className={styles.root_text} style={{ textAlign: 'end' }}>
        {addSpaceNumber(taxe.amount_returned)}
      </p>
      <div>
        <p className={styles.root_text} style={{ textAlign: 'end' }}>
          <span style={{ display: 'flex', justifyContent: 'right' }}>
            {taxe?.fns_amount ? addSpaceNumber(taxe.fns_amount) : null}
            <span style={{ width: '38px' }}>
              <BillIcon width={22} height={22} fill={'#002CFB'} />
            </span>
          </span>
        </p>
      </div>
    </div>
  );
};
